import { LANG_MAP } from './loginLang.js';

const fallbackLang = process.env.VUE_APP_ENV === 'intl' ? 'en_US' : 'zh_CN';

let cachedLangData = null;
let cachedLangRegion = null;

export const t = (key) => {
  const langRegion = sessionStorage.getItem('query_lang') || 'en_US';

  if (langRegion !== cachedLangRegion) {
    cachedLangRegion = langRegion;
    cachedLangData = LANG_MAP[langRegion] || LANG_MAP[fallbackLang]; // Fallback to configured language
  }

  if (cachedLangData && cachedLangData[key] !== undefined) {
    return cachedLangData[key];
  }

  const defaultLangData = LANG_MAP[fallbackLang]; // Use dynamic fallback
  if (defaultLangData && defaultLangData[key] !== undefined) {
    return defaultLangData[key];
  }

  return key;
};
